import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import mapTick from "../../../asset/images/maptick.svg"
import { decryptData, encryptData, getName } from "../../../CommonMethhods/CommonMethods";
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import { axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function PartnerDetailComponent(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerCode = localStorage.getItem("getPartnerCode");
  const partnerDetails = props.partnerDetails;
  const id = props.id;
  const errorMsg = props.errorMsg;
  const getPartnerId = props.getPartnerId;
  const [loader, setLoader] = useState(false);
  const [deactivatedAccount, setDeactivatedAccount] = useState(false);
  const [mapSuccessModal, setMapSuccessModal] = useState(false);
  const [activateAccount, setActivateAccount] = useState(false);
  const [activeSuccessModal, setActiveSuccessModal] = useState(false);
  const [activeVal, setActiveVal] = useState(true);
  const [ssoLoader, setSsoLoader] = useState(false);

  const navigate = useNavigate();


  const deactivatePartner = async (checkVal) => {
    setActiveVal(checkVal);
    setLoader(true);
    let payloadReq = {
      id: parseInt(id),
      isActive: checkVal,
    }
    let payloadApproved = encryptData(JSON.stringify(payloadReq));
    try {
      const getDetail = await axiosSsoText.put(
        partner_Admin.GetPartnerById,
        payloadApproved,
      );
      const res = decryptData(getDetail?.data);
      let decryptedRes = JSON.parse(res);
      if (decryptedRes?.status === 0) {
        if (checkVal === false) {
          setMapSuccessModal(true);
        }
        else {
          setActiveSuccessModal(true);
        }
        getPartnerId();
        // toast.success(decryptedRes?.data?.message);
      } else {
        toast.error(decryptedRes?.data?.message)
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setLoader(false);

    }

  };

  const partnerSideSsoLogin = async () => {
    setSsoLoader(true);
    let payloadRequest = {
      pcode: partnerCode,
    }
    let payloadApprovedData = encryptData(JSON.stringify(payloadRequest));
    try {
      const getDetail = await axiosSsoText.post(
        partner_Admin.GET_PARTNER_SSO,
        payloadApprovedData,
      );
      const res = decryptData(getDetail?.data);
      let decryptedRes = JSON.parse(res);
      console.log(decryptedRes, "decryptedRes");
      if (decryptedRes?.status === 0) {

        let value = decryptedRes?.data?.info;
        if(value?.access_token && value?.id_token){
          let JWTRes = jwt_decode(value?.access_token);

          localStorage.setItem("partnerFlag", true);
          localStorage.setItem("partnerSsoToken", value?.access_token);
          localStorage.setItem("partnerUserId", value?.userId);
          localStorage.setItem("partnerUserName", JWTRes?.rmName);
          localStorage.setItem("partnerId_token", value?.id_token);
          localStorage.setItem("partnerMobileNo", value?.mobile_no)

          if ("Permissions" in JWTRes) {
            if (JWTRes.Permissions === "null") {
              toast.error("No permission provided to this user");
              throw Error("Invalid");
            } else{
              let projectList = JSON.parse(JWTRes?.Permissions)?.data?.projects;
              let DuplicateArray = [];
              Object.keys(projectList).forEach((key) => {
                // if (!(projectList[key].Name === "Partner")) {
                //   delete projectList[key];
                // } else {
                  DuplicateArray.push(projectList[key]);
  
                  if (projectList[key].Name === "Partner") {
                    localStorage.setItem("partnerRoleNew",projectList[key]?.Role?.Name);
                    
                  }
                // }
              });
              localStorage.setItem("partnerProject", JSON.stringify(DuplicateArray));

              const data = DuplicateArray;
              const endpoints = data.flatMap(item =>
                item.Modules.flatMap(module => [
                  module.projectEndpoint,
                  ...module.SubModule.map(subModule => subModule.subprojectEndpoint)
                ])
              ).filter(endpoint => endpoint);

              const endpointList = endpoints.map((item) => {               
                if (!item.startsWith("/")) {
                  item = `/${item}`
                }
                return item
                
  
              })

              localStorage.setItem("PartnerEndpoints", JSON.stringify(endpointList))
              window.open("/partner-side-dashboard", "_blank")

            }
          }
        }else {
          throw Error("Case Invalid");
        }
      } else {
        toast.error(decryptedRes?.message);
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setSsoLoader(false);
    }
  };


  const handleViewDashboard = () => {
    partnerSideSsoLogin();
  }

  const deactivateBtn = (value) => {
    deactivatePartner(value);
    setDeactivatedAccount(false);
  }

  const activateBtn = (trueVal) => {
    deactivatePartner(trueVal);
    setActivateAccount(false);
  }


  return (
    <>
      <div className="card-box partner-detail-card bottom-25">
        <div className="row">
          <div className="partner-detail-card-box col-md-4">

            <div className="partner-detail-namewrapper">
              {partnerDetails !== undefined || null ? (
                <div>
                  <p className="partner-detail-name">{getName(partnerDetails?.nameOnPan)}</p>
                  {/* <span className="icon-Edit"></span> */}
                </div>
              ) : <div>
                <p className="partner-detail-name">NA</p>
                {/* <span className="icon-Edit"></span> */}
              </div>
              }
            </div>

            <div>
              <p className="partner-detail-fullname">{partnerDetails?.nameOnPan}</p>
              <p className="partner-code">
                Partner Code <span>{partnerDetails?.partnerCode || "-"}</span>
              </p>
              <div className="view-button">
              {errorMsg?.length > 0 ?
                <a className="view-dash">View Dashboard</a>
                :
                <a className="view-dash"
                  // href="https://uat-cosmos.bajajfinservsecurities.in/partner-side-dashboard"
                  target="_blank" onClick={()=>handleViewDashboard()}>View Dashboard</a>
                  
              }
              {ssoLoader ?
                  <SmallLoader />
                  : ""
              }
              </div>

            </div>
          </div>
          <div className="partner-detail-card-box-right col-md-8">
            <div className="partner-detail-card-item">
              <p className="card-item-subtitle">SAP Code</p>
              <p className="card-item-value">{partnerDetails?.sapCode || "-"}</p>
            </div>
            <div className="partner-detail-card-item">
              <p className="card-item-subtitle">Revenue Sharing</p>
              <p className="card-item-value">{partnerDetails?.revenueSharing || "-"}</p>
            </div>
            <div className="partner-detail-card-item">
              {errorMsg?.length > 0 ?
                <button
                  className="deactivate-btn"
                  onClick={() => setActivateAccount(true)}
                >
                  Activate
                </button>
                :
                <button
                  className="deactivate-btn"
                  onClick={() => setDeactivatedAccount(true)}
                >
                  Deactivate
                </button>
                // : <button 
                // className="deactivate-btn" 
                // onClick={()=>setDeactivatedAccount(true)}
                // >
                //   Deactivate
                //   </button>

              }

            </div>
          </div>
        </div>
      </div>

      <Modal
        show={deactivatedAccount}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            {/* <img src={mapTick} className="arrow-tick" alt="mapTick"/> */}
            <div>
              <h2 className="modal-title">Are you Sure?</h2>
              <p className="modal-desc">You want to Deactivate your account</p>
            </div>
            <div className="btn-wrapper">
              <button className="yes-btn signup-btn"
                type="submit"
                onClick={() => deactivateBtn(false)}
              >
                {loader ?
                  <SmallLoader />
                  :
                  <>
                    Yes
                  </>
                }

              </button>

              <button
                className="no-btn"
                onClick={() => setDeactivatedAccount(false)}
              >
                No
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={activateAccount}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            {/* <img src={mapTick} className="arrow-tick" alt="mapTick"/> */}
            <div>
              <h2 className="modal-title">Are you Sure?</h2>
              <p className="modal-desc">You want to Activate your account</p>
            </div>
            <div className="btn-wrapper">
              <button className="yes-btn signup-btn"
                type="submit"
                onClick={() => activateBtn(true)}
              >
                {loader ?
                  <SmallLoader />
                  :
                  <>
                    Yes
                  </>
                }

              </button>

              <button
                className="no-btn"
                onClick={() => setActivateAccount(false)}
              >
                No
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Success */}

      <Modal
        show={mapSuccessModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <img src={mapTick} className="arrow-tick" alt="mapTick" />
            <div>
              <h2 className="modal-title">Deactivated Successfully</h2>
              {/* <p className="modal-desc">You want to Deactivate your account</p> */}
            </div>
            <div className="btn-wrapper">
              <button className="yes-btn" onClick={() => setMapSuccessModal(false)}>ok</button>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      <Modal
        show={activeSuccessModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <img src={mapTick} className="arrow-tick" alt="mapTick" />
            <div>
              <h2 className="modal-title">Activated Successfully</h2>
              {/* <p className="modal-desc">You want to Deactivate your account</p> */}
            </div>
            <div className="btn-wrapper">
              <button className="yes-btn" onClick={() => setActiveSuccessModal(false)}>ok</button>
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
}

export default PartnerDetailComponent;
